const TabsHeader = () => {
  const tabs = [
    { id: "styled-tabA", target: "#tabA", label: "الإجمالي" },
    { id: "styled-tabB", target: "#tabB", label: "تبرعات المشروع" },
    { id: "styled-tabC", target: "#tabC", label: "تبرع سريع" },
    { id: "styled-tabD", target: "#tabD", label: "مدفوعات الاستقطاع" },
  ];

  return (
    <div className="print:hidden">
      <ul
        className="relative -mx-1 mb-4 flex flex-nowrap items-center gap-1 overflow-x-auto whitespace-nowrap rounded-2xl border border-gray-100 bg-gradient-to-l from-purple-50/30 via-white to-purple-50/20 p-1.5 backdrop-blur-sm [-ms-overflow-style:none] [scrollbar-width:none] dark:border-gray-700/60 dark:from-purple-950/15 dark:via-gray-800 dark:to-purple-950/10 [&::-webkit-scrollbar]:hidden"
        id="default-styled-tab"
        data-tabs-toggle="#tab-financial"
        data-tabs-active-classes="bg-gradient-to-br from-purple-800 to-purple-950 text-white shadow-md shadow-purple-900/25 ring-1 ring-purple-900/10 dark:from-purple-600 dark:to-purple-800"
        data-tabs-inactive-classes="text-gray-600 hover:bg-white hover:text-purple-900 dark:text-gray-400 dark:hover:bg-gray-700/60 dark:hover:text-purple-300"
        role="tablist"
      >
        {tabs.map((tab) => (
          <li role="presentation" key={tab.id} className="shrink-0">
            <button
              className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-2xl px-4 py-2.5 text-sm font-medium tracking-tight transition-all duration-200"
              id={tab.id}
              data-tabs-target={tab.target}
              type="button"
              role="tab"
              aria-controls={tab.target.substring(1)}
              aria-selected="false"
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TabsHeader;
